import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actionBox"]

  showActions() {
    this.actionBoxTarget.classList.remove("hidden")
  }

  hideActions() {
    this.actionBoxTarget.classList.add("hidden")
  }

  toggleCheckBox(event) {
    const clickedElement = event.target
    const tagName = clickedElement.tagName.toLowerCase()
    const excludedTags = ["a", "i", "button", "input"]
    const checkbox = this.element.querySelector('input[type="checkbox"]')

    if (checkbox && !excludedTags.includes(tagName)) {
      checkbox.checked = !checkbox.checked
      checkbox.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

}
